const mutationtypes = Object.freeze({
  UPDATE_SINGLEENTRYLISTSELECT_STATE: 'updateSingleEntryListSelectState',
  UPDATE_SINGLEENTRYNAVIGATIONBACKBUTTON_STATE: 'updateSingleEntryNavigationBackButtonState',
  UPDATE_SINGLEENTRYLISTTABLESEARCH_STATE: 'updateSingleEntryListTableSearchState',
  UPDATE_SINGLEENTRYLIST_SELECTED_YEAR: 'updateSingleEntryListSelectedYear',
  UPDATE_SINGLEENTRYLIST_SELECTED_PERIODAT: 'updateSingleEntryListSelectedPeriodAt',
  UPDATE_SINGLEENTRYLIST_SELECTED_PERIODTO: 'updateSingleEntryListSelectedPeriodTo',
  UPDATE_SINGLEENTRYLIST_SELECTED_FACILITY: 'updateSingleEntryListSelectedFacility',
  UPDATE_SINGLEENTRYLIST_COSTCENTER_FILTER: 'updateSingleEntryListCostCenterFilter',
  UPDATE_SINGLEENTRYLIST_GENERALLEDGERACCOUNT_FILTER: 'updateSingleEntryListGeneralLedgerAccountFilter',
  UPDATE_SINGLEENTRYLIST_PROJECT_FILTER: 'updateSingleEntryListProjectFilter',
  UPDATE_SINGLEENTRYLIST_VIEW_MODE: 'updateSingleEntryListViewMode'
})

export default mutationtypes
